import { init } from 'priority-nav'
import { Dictionary } from 'utility/helpers/Dictionary'

const PriorityNav = {
	el: {
		root: document.querySelector<HTMLElement>('.pnav'),
		// root: document.querySelector<HTMLElement>('.page-subnav'),
	},
	init() {

		if (this.el.root) {
			/* eslint-disable */
			// @ts-ignore
			const pn = init({
				mainNavWrapper: '.pnav', // mainnav wrapper selector (must be direct parent from mainNav)
				mainNav: '.pnav__list', // mainnav selector. (must be inline-block)
				navDropdownLabel: Dictionary('pnButtonText'),
				navDropdownBreakpointLabel: Dictionary('pnButtonTextMobile'),
				navDropdownClassName: 'pnav__dropdown', // class used for the dropdown.
				navDropdownToggleClassName: 'pnav__dropdown-toggle', // class used for the dropdown toggle.
				breakPoint: 780
			})
			/* eslint-enable */
		}
	}
}

export default PriorityNav
